export const COACH_ITEM_SHARED_ITEM_TYPENAME = 'coach';
export const COACH_ITEM_SHARED_ITEM_LABEL = 'COACH';
